import { TableContainer, Table, TableHead, TableRow, Typography, TableBody, Button, Grid, Box} from '@material-ui/core';
import { AddBox, Cancel, Check, Delete, Edit } from '@material-ui/icons';
import { AutocompleteForm, FormatNumber, TextFieldNumber } from 'components';
import { StyledTableCell } from 'components/TablaV2';
import { useState } from 'react';
import { Controller } from 'react-hook-form';

export default function ListaMiembrosTarea({ personas, control, name, rules, totalHAsignar, defaultResponsables, errors }) {
    const [nuevoMiembro, setNuevoMiembro] = useState({ idpersona: null, horas: null });

    return (
        <Controller
            render={({ value, onChange }) => {
                const error = {
                    p: 1,
                    bgcolor: 'background.paper',
                    m: 1,
                    borderRadius: 1,
                    boxShadow:
                        '0px 7px 8px -7px rgb(255 155 155 / 100%), 0px 0px 5px 1px rgb(141 0 0 / 100%), 2px 0px 2px 1px rgb(255 155 155 / 90%)'
                };
                const horasTarea = (defaultResponsables || [])?.reduce((horas, persona) => horas + Number(persona.horas), 0);
                const horasRestantes = value.reduce((horas, persona) => horas - persona.horas, totalHAsignar + horasTarea);

                const idPersonaSeleccionado = value.map(miembro => miembro.idpersona);
                const AgregarMiembro = nuevoMiembro => () => {
                    onChange([...value, nuevoMiembro]);
                    setNuevoMiembro({
                        idpersona: null,
                        horas: horasRestantes - nuevoMiembro.horas * 2 <= 0 ? horasRestantes - nuevoMiembro.horas : nuevoMiembro.horas
                    });
                };
                const EliminarMiembro = miembroEliminar => () => {
                    onChange(value.filter(miembro => miembro.idpersona != miembroEliminar.idpersona));
                };
                const habilitarEditar = (miembroEditar, habilitar) => () => {
                    onChange(
                        value.map(miembro =>
                            miembro.idpersona == miembroEditar.idpersona
                                ? { ...miembroEditar, accion: habilitar ? 'updA' : null }
                                : { ...miembro, accion: null }
                        )
                    );
                    if (nuevoMiembro.horas > 0 && habilitar) setNuevoMiembro({ persona: null, horas: null });
                };
                return (
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="body2">
                                * Horas pendientes por asignar: <b>{horasRestantes}</b>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                        <Box sx={errors?.responsables ? error : {}}>
                            <TableContainer>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ width: '60%' }}>MIEMBRO DEL EQUIPO</StyledTableCell>
                                            <StyledTableCell align="right" style={{ width: '15%' }}>
                                                HORAS
                                            </StyledTableCell>
                                            <StyledTableCell padding="none"></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {value.map(miembro => {
                                            return (
                                                <TableRow key={miembro.idpersona}>
                                                    <StyledTableCell component="th">{miembro.nombre}</StyledTableCell>
                                                    <StyledTableCell>
                                                        {miembro.accion == 'updA' ? (
                                                            <TextFieldNumber
                                                                onChange={horas =>
                                                                    habilitarEditar({ ...miembro, horasPrevias: horas }, true)()
                                                                }
                                                                value={miembro.horasPrevias}
                                                                isAllowed={({ floatValue, formattedValue }) =>
                                                                    formattedValue === '' ||
                                                                    floatValue <= horasRestantes + Number(miembro.horas)
                                                                }
                                                                suffix=" hr"
                                                            />
                                                        ) : (
                                                            <FormatNumber type="horas" value={miembro.horas || 0} />
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <>
                                                            <Button onClick={EliminarMiembro(miembro)}>
                                                                <Delete />
                                                            </Button>
                                                        </>
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        })}
                                        {personas.some(
                                            persona =>
                                                !idPersonaSeleccionado.includes(persona.idpersona) &&
                                                !value.some(persona => persona.accion == 'updA')
                                        ) && (
                                            <TableRow>
                                                <StyledTableCell component="th">
                                                    <AutocompleteForm
                                                        label=""
                                                        onChange={persona =>
                                                            persona
                                                                ? setNuevoMiembro({ ...nuevoMiembro, ...persona })
                                                                : setNuevoMiembro({ ...nuevoMiembro, idpersona: null })
                                                        }
                                                        value={nuevoMiembro.idpersona ? nuevoMiembro : null}
                                                        options={personas.filter(
                                                            persona => !idPersonaSeleccionado.includes(persona.idpersona)
                                                        )}
                                                        optionSelected={{
                                                            id: 'idpersona',
                                                            label: 'nombre'
                                                        }}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <TextFieldNumber
                                                        onChange={horas => setNuevoMiembro({ ...nuevoMiembro, horas: horas })}
                                                        isAllowed={({ floatValue, formattedValue }) =>
                                                            formattedValue === '' || floatValue <= horasRestantes
                                                        }
                                                        value={nuevoMiembro.horas}
                                                        suffix=" hr"
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Button
                                                        disabled={!nuevoMiembro.idpersona || nuevoMiembro.horas <= 0}
                                                        onClick={AgregarMiembro(nuevoMiembro)}
                                                    >
                                                        <AddBox />
                                                    </Button>
                                                </StyledTableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {errors?.responsables && ( 
                                        <Typography textAlign="center" style={{color:'#FF5733'}}>
                                            {errors?.responsables }
                                        </Typography>
                                
                             )}  
                            </Box>     
                        </Grid>
                    </Grid>
                );
            }}
            defaultValue={defaultResponsables || []}
            rules={rules}
            name={name}
            control={control}
        />
    );
}
